// extracted by mini-css-extract-plugin
export default {"RMSMultiSizeImageBlock":"RMSMultiSizeImageBlock_RMSMultiSizeImageBlock__q3upK"};